/*
 * Created by TUTEHUB.
 * Copyright © TUTEHUB. All rights reserved.
 * ------------------------
 * Non-disclosure Terms
 * ------------------------
 * These codes are TUTEHUB's property, as the developer, such as employee, contractor, and intern, working for TUTEHUB cannot disclose, spread, copy, preserve, sell, and do other activities without the consent of TUTEHUB.
 * Technique Support: jobyme88.com
 */

import React from 'react'

export default function SmallItem(props) {
    return (
        <div className={`small-item ${props.className}`}>
            <h3 className="title">{props.title}</h3>
            <p className="des">{props.des}</p> 
        </div>
    )
}
